import React, {useEffect, useState} from 'react';
import {HOME_PATH} from "../../routes";
import useFeature from "../../useFeature";
import {observer} from "mobx-react";
import {CartCheckoutFeature} from "./CartCheckoutFeature";
import {useApplication} from "../../ApplicationProvider";
import {Box, Button, IconButton, InputAdornment, Modal, TextField, Typography} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import MoneyRenderer from "../utils/MoneyRenderer";
import {useNavigate} from "react-router-dom";
import {SelectDeliveryPointFeature} from "../products/detail/SelectDeliveryPointFeature";
import {ModalDeliveryPointAndPurchaseOrderNumber} from "../products/detail/ModalDeliveryPointAndPurchaseOrderNumber";
import successToast from "../../components/toast/SuccessToast";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import {
    ModalCantEditOrderWhenItsNotInInitialState
} from "../products/detail/ModalCantEditOrderWhenItsNotInInitialState";
import FileUploadSection from "../../components/FileUploadSection/FileUploadSection";


const useToastNotifications = (pedidoInicial, diaNoLaborable, aplicaAlertaAumento) => {
    const [toastParams, setToastParams] = useState(null);

    const errorFechaMessage = (fechaProgramada) => ({
        title: `No es posible generar el pedido para la fecha ${fechaProgramada.getDate()} de ${fechaProgramada.toLocaleString('es-MX', {month: 'long'})} de ${fechaProgramada.getFullYear()}`,
        text: "Debo modificar la fecha de entrega"
    });

    const errorCantidadMessage = () => ({
        title: "Mínimo no superado",
        text: "Debe ingresar un mínimo de 2 unidades en total."
    });

    const errorEstadoMessage = () => ({
        title: "No se puede efectuar la compra",
        text: "Debe regularizar el estado administrativo del cliente"
    });

    const diaNoLaborableMessage = (mensaje) => ({
        title: "Día no laborable",
        text: mensaje
    });

    const aplicaAlertaAumentoMessage = (fechaAplicaAumento) => ({
        title: "Actualización de Precios",
        text: `A partir de la fecha ${fechaAplicaAumento.toLocaleDateString()} se aplicará un aumento en algunos de los productos.`
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);

        if (queryParams.get('ErrorFecha') === 'True') {
            setToastParams(errorFechaMessage(pedidoInicial.FechaProgramada));
        } else if (queryParams.get('ErrorCantidad') === 'True') {
            setToastParams(errorCantidadMessage());
        } else if (queryParams.get('ErrorEstado') === 'True') {
            setToastParams(errorEstadoMessage());
        } else if (diaNoLaborable) {
            setToastParams(diaNoLaborableMessage(diaNoLaborable.Mensaje));
        } else if (aplicaAlertaAumento) {
            setToastParams(aplicaAlertaAumentoMessage(pedidoInicial.Cliente.ArticulosListaPrecio[0].FechaAplicaAumento));
        }
    }, [pedidoInicial, diaNoLaborable, aplicaAlertaAumento]);

    return toastParams;
};


const CartCheckoutScreen = () => {
    const application = useApplication()
    const navigator = useNavigate()
    const feature = useFeature(() => new CartCheckoutFeature(application))
    const selectDeliveryPointFeature = useFeature(() => new SelectDeliveryPointFeature(application))

    const handleFilesChange = (files) => {
        feature.handlePaymentProofFilesChange(files);
    };
    const isFeatureReady = () => {
        return feature && feature.loaded && selectDeliveryPointFeature && selectDeliveryPointFeature.loaded;
    }
    let articles = [];
    let index = 0;

    if (isFeatureReady() && feature._application && feature._application.hasOrder()) {
        articles = feature._application.getOrder().articles;
        // useToastNotifications(feature.initialOrder, feature.nonWorkingDay, feature.applyIncreaseAlert);
    }

    return (isFeatureReady() &&
        <div className="container">
            <div className="row">
                <div className="col-md-10 col-md-offset-1">
                    {feature._application.hasOrder() && <div className="row">
                        <div className="col-xs-12">
                            <div className="container-info-pedido reclamo datos-pedido">
                                <div className="row" style={{display: 'flex',alignItems: 'center'}}>
                                    <div className="col-sm-8">
                                        <div className="row datos-pedido-box">
                                            <div className="col-xs-4 col-sm-3">
                                                <p className="general-title text-right-left">Punto de Entrega</p>
                                            </div>
                                            <div className="col-xs-8 col-sm-9">
                                                <div className="item-box">
                                                    <span className="label label-default font10">
                                                      {feature.order().deliverySite.deliverySiteName}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row datos-pedido-box">
                                            <div className="col-xs-4 col-sm-3">
                                                <p className="general-title text-right-left">Número de orden de compra</p>
                                            </div>
                                            <div className="col-xs-8 col-sm-9">
                                                <div className="item-box">
                                                    <span className="descripcion-item-box" style={{position: 'relative', top: '-8px'}} >
                                                      {feature.order().customersOrderNumber}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row datos-pedido-box">
                                            <div className="col-xs-4 col-sm-3">
                                                <p className="general-title text-right-left">Fecha de Pedido</p>
                                            </div>
                                            <div className="col-xs-8 col-sm-9">
                                                <div className="item-box">
                                                    <p className="descripcion-item-box">
                                                        {feature.order().deliveryDate}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 text-right">
                                        <IconButton
                                            onClick={() => {selectDeliveryPointFeature.openDeliveryPointModal()}}
                                            aria-label="Editar"
                                        >
                                            <EditIcon sx={{ fontSize: "1.3em" }}/>
                                        </IconButton>
                                    </div>
                                    <ModalCantEditOrderWhenItsNotInInitialState
                                        open={feature.isModalCantEditOrderOpened}
                                        feature={feature}
                                    />
                                    <ModalDeliveryPointAndPurchaseOrderNumber
                                        open={selectDeliveryPointFeature.isDeliveryPointModalOpened}
                                        handleSetDelivery={(deliveryPointName, deliveryDate, purchaseOrderNumber) => { selectDeliveryPointFeature.setDelivery(deliveryPointName, deliveryDate, purchaseOrderNumber) }}
                                        puntosEntrega={selectDeliveryPointFeature.deliverySites}
                                        feature={selectDeliveryPointFeature}
                                        navigator={navigator}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div className={`message-empty ${articles.length ? 'hide' : ''}`}>
                        <i className="pe-7s-shopbag"></i>
                        <h3>Tu carrito de compras está vacío.</h3>
                        <h4>Te invitamos a que pases y conozcas nuestros panes</h4>
                        <a href={HOME_PATH} className="btn btn-primary btn-lg">Hacé tu pedido</a>
                    </div>
                    {articles.length > 0 && <section className={`${articles.length ? '' : 'hide'}`}>
                        <div className="table-responsive margintop40">
                            <table className="table table-pedidos">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th style={{textAlign: 'left'}}>ARTÍCULO</th>
                                    <th style={{textAlign: 'center'}}>CONTENIDO CAJA</th>
                                    <th style={{textAlign: 'center'}}>CANTIDAD</th>
                                    <th style={{textAlign: 'center'}}>TOTAL</th>
                                    <th style={{textAlign: 'center'}}>ACCIONES</th>
                                </tr>
                                </thead>
                                <tbody id="tbody">
                                {articles.sort().map((articleInOrder, index) => (
                                    <ArticuloRow key={index} articuloEnOrden={articleInOrder} feature={feature}/>
                                ))}
                                </tbody>
                            </table>
                        </div>

                        {feature.advancePaymentProofNeeded && (
                            <>
                                <FileUploadSection 
                                    onFilesChange={handleFilesChange} 
                                    placeholder="Debe ingresar comprobante de pago para continuar"
                                    isRequired={true}
                                    initialFiles={feature.paymentProofFiles}
                                />
                                <div className="clearfix"></div>
                                <hr className="margintop30 full-xs"/>
                            </>
                        )}

                        <div className="totales-container">
                            <table className="table-totales">
                                <tbody>
                                <tr>
                                    <td className="text-right">SUBTOTAL</td>
                                    <td className="text-right">{MoneyRenderer(feature.orderPrices.articlesTotalPrice)}</td>
                                </tr>
                                <tr>
                                    <td className="text-right">IVA</td>
                                    <td className="text-right">{MoneyRenderer(feature.orderPrices.totalVAT)}</td>
                                </tr>
                                <tr>
                                    <td className="text-right">IIBB</td>
                                    <td className="text-right">{MoneyRenderer(feature.totalGrossIncomeTaxes())}</td>
                                </tr>
                                <tr className="total-row">
                                    <td className="text-right">TOTAL</td>
                                    <td className="text-right">{MoneyRenderer(feature.orderPrices.total)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="clearfix"></div>

                        <hr className="margintop30 full-xs"/>

                        <div style={{marginTop: '20px', fontSize: '0.85rem', color: '#666', fontStyle: 'italic', textAlign: 'left', padding: '0 15px'}}>
                            * Los precios, impuestos y la disponibilidad de los productos exhibidos son estimativos y podrán modificarse sin previo aviso; el monto definitivo será el indicado en la factura correspondiente.
                        </div>

                        {/*<div className={`row recommendations ${feature.recommended.length === 0 ? 'hide' : ''}`}>*/}
                        {/*    <div className="col-xs-12">*/}
                        {/*        <div className="text-center">*/}
                        {/*            <div className="title-recommend brandonMd">Te recomendamos que pruebes</div>*/}
                        {/*            <div className="row">*/}
                        {/*                <div className="col-xs-12">*/}
                        {/*                    <div className="owl-carousel" id="checkout-carousel">*/}
                        {/*                        {feature.recommended.map(item => (*/}
                        {/*                            <div className="relative product-item" key={item.Id}>*/}
                        {/*                                <a href={ID_PRODUCT_DETAIL_PATH}*/}
                        {/*                                   className="img-box">*/}
                        {/*                                    <img src={item.Producto.Archivos}*/}
                        {/*                                         className="img-responsive img-producto-categoria"*/}
                        {/*                                         alt="Foto de Categoría"/>*/}
                        {/*                                </a>*/}
                        {/*                                <div className="footer-product">*/}
                        {/*                                    <a href={ID_PRODUCT_DETAIL_PATH}*/}
                        {/*                                       className="h5 title-product show">{item.Producto.Nombre}</a>*/}
                        {/*                                    <p className="h3 none">$ <span*/}
                        {/*                                        id="precio-producto">XX,XX</span></p>*/}
                        {/*                                    <a className={`btn btn-primary btn-sm btn-outlined ${*/}
                        {/*                                        feature.initialOrder.VerModalMultiplePuntoEntrega*/}
                        {/*                                            ? 'punto-entrega-elegir'*/}
                        {/*                                            : 'agregar-articulo'}`*/}
                        {/*                                    }*/}
                        {/*                                       href={`#${item.Id}`}>Añadir</a>*/}
                        {/*                                </div>*/}
                        {/*                            </div>*/}
                        {/*                        ))}*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="margintop60 hidden-xs"></div>
                        <div className="checkout-fixed" item-tabla-articulo="">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-11 col-md-offset-1">
                                        <div className="row">
                                            <div className="col-xs-6">
                                                <div>
                                                    <p className="general-title clearmargin">Total:</p>
                                                    <p className="font26 brandonMd clearmargin">$68.820,00</p>
                                                </div>
                                            </div>
                                            <div className="col-xs-6 margintop5">
                                                <div className="text-right hidden-xs">
                                                    <a href="/Frontend/ConfirmarCompra/a289ca1f-d627-fab9-20b3-3a11bb33c219"
                                                       className="btn btn-primary checkout-fixed-btn hidden-xs">Confirmar
                                                        compra</a>
                                                </div>
                                                <div className="text-right visible-xs">
                                                    <a href="/Frontend/ConfirmarCompra/a289ca1f-d627-fab9-20b3-3a11bb33c219"
                                                       className="btn btn-primary checkout-fixed-btn visible-xs">Pedir</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>}
                    {articles.length > 0 &&
                        <div className={`checkout-fixed ${articles.length ? '' : 'hide'}`} item-tabla-articulo="">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-11 col-md-offset-1">
                                        <div className="row">
                                            <div className="col-xs-6">
                                                <div>
                                                    <p className="general-title clearmargin">Total:</p>
                                                    <p className="font26 brandonMd clearmargin">{MoneyRenderer(feature.orderPrices.total)}</p>
                                                </div>
                                            </div>
                                            <div className="col-xs-6 margintop5">
                                                <div className="text-right hidden-xs">
                                                    <button
                                                        className={`btn checkout-fixed-btn hidden-xs ${feature.canConfirmOrder ? 'btn-primary' : ''}`}
                                                        disabled={!feature.canConfirmOrder}
                                                        onClick={() => feature.canConfirmOrder && feature.confirmOrder(() => navigator(HOME_PATH))}
                                                        style={{
                                                            backgroundColor: feature.canConfirmOrder ? '' : '#6c757d',
                                                            borderColor: feature.canConfirmOrder ? '' : '#6c757d',
                                                            color: feature.canConfirmOrder ? '' : '#ffffff',
                                                            opacity: feature.canConfirmOrder ? 1 : 0.8,
                                                            cursor: feature.canConfirmOrder ? 'pointer' : 'not-allowed'
                                                        }}>
                                                        Confirmar compra
                                                    </button>
                                                </div>
                                                <div className="text-right visible-xs">
                                                    <a
                                                        onClick={() => feature.confirmOrder(() => navigator(HOME_PATH))}
                                                        className="btn btn-primary checkout-fixed-btn visible-xs"
                                                        style={{ display: "inline-block", textAlign: "center", width: "100%" }}
                                                    >
                                                        Confirmar
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        </div>
    );
};

const ArticuloRow = ({articuloEnOrden, feature}) => {
    const [modalOpen, setModalOpen] = useState(false);

    function handleClickRemoveArticle() {
        feature.deleteOrdersArticle(articuloEnOrden)
    }

    const priceAmountAndTotal = feature.calculatePriceAmountAndTotal(articuloEnOrden);
    return <tr>
        <td style={{textAlign: 'left'}}>
            <img className="img-responsive img-order-product" alt="Foto de Producto"
                 src={feature.productImage(articuloEnOrden)}/>
        </td>
        <td style={{textAlign: 'left'}}>{articuloEnOrden.fantasyName}</td>
        <td style={{textAlign: 'center'}}>{articuloEnOrden.itemsAmount} {feature.itemUnitAbbreviation(articuloEnOrden)}</td>
        <td style={{textAlign: 'center'}}><span>{articuloEnOrden.amount}</span> cajas</td>
        <td style={{textAlign: 'left'}}>{MoneyRenderer(priceAmountAndTotal.total)}</td>
        <td>
            <IconButton onClick={handleClickRemoveArticle}>
                <DeleteIcon color="error"/>
            </IconButton>
            <IconButton onClick={() => setModalOpen(true)}>
                <EditIcon/>
            </IconButton>
        </td>
        <ModalAddToCart
            feature={feature}
            isOpened={modalOpen}
            setModalOpen={setModalOpen}
            article={articuloEnOrden}
            orderArticlePrices={priceAmountAndTotal}
            handleAddToCart={async (quantity) => {
                await feature.addProductToCartAndGetOrderPrices(articuloEnOrden, quantity)
                setModalOpen(false)
                successToast("Su producto ha sido agregado")
            }}
        />
    </tr>;
}

const ModalAddToCart = ({feature, isOpened, setModalOpen, article, orderArticlePrices, handleAddToCart}) => {
    // TODO: if this changes remember to change modal on ProductDetailScreen
    const [quantity, setQuantity] = useState('');

    const hasKnownItemPrice = orderArticlePrices.itemPrice !== null && orderArticlePrices.itemPrice !== undefined;

    const handleQuantityChange = (value) => {
        setQuantity(value);
    };

    const aQuantityWasEntered = quantity !== '' && quantity !== null && quantity !== undefined;


    return (
        <>
            <input type="hidden" name="aniadir-articulo-id"/>
            <Modal open={isOpened} onClose={() => setModalOpen(false)} aria-labelledby="add-cart-modal-title">
                <Box sx={{
                    ...style,
                    width: '80%',
                    maxWidth: '800px',
                    borderRadius: '7px',
                    maxHeight: "90vh",
                    overflowY: "auto",
                    padding: "20px",
                    backgroundColor: "#fff",
                    "@media (max-width: 768px)": {
                        width: "95%",
                        maxWidth: "100%",
                        padding: "15px",
                    },
                }}>
                    <Box sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <p className="general-title title-info-product">Añadir al carrito</p>
                        <Button
                            onClick={() => setModalOpen(false)}
                            style={{
                                position: 'absolute',
                                top: '25px',
                                right: '25px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                            }}
                        >
                            <p className="general-title title-info-product"
                               style={{margin: 0, fontSize: '12px'}}>Cerrar</p>
                            <FontAwesomeIcon icon={faTimesCircle} className="general-title title-info-product"/>
                        </Button>
                    </Box>
                    <Box className="modal-body">
                        <Box className="container-fluid">
                            <Box className="row">
                                <Box className="col-xs-12 col-sm-6 col-sm-push-6 clearpadding">
                                    <Box
                                        className="img-add-cart"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'right',
                                        }}
                                    >
                                        <img
                                            src={feature.productImage(article)}
                                            alt="Foto de Categoría"
                                            className="img-responsive"
                                            style={{
                                                width: 'auto',
                                                height: 'auto',
                                                objectFit: 'contain',
                                                marginLeft: '40px',
                                                marginTop: '40px'
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Box className="col-xs-12 col-sm-6 col-sm-pull-6 clearpadding">
                                    <Typography variant="h5" sx={{ marginBottom: '10px', color: '#ffffff' }}>
                                        <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}> {article.NombreFantasia} </div>
                                    </Typography>
                                    <Box className="visible-xs">
                                        <Box className="text-center">

                                        </Box>
                                    </Box>
                                    <table className="table" style={{ width: '100%', border: '' , borderCollapse: 'collapse' }}>
                                        <tbody style={{ border: '' }}>
                                        <tr style={{ borderBottom: '1px solid #ddd' }}>
                                            <td style={{ width: '10%', textAlign: 'left', paddingLeft: '0px' }}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        color: '#5e5d5d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    <Inventory2OutlinedIcon/>
                                                </span>
                                            </td>
                                            <td style={{ width: '60%', textAlign: 'left', paddingLeft: '10px' }}>Cada Unidad</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontSize: '18px', color: '#c1a17d' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>
                                                    {hasKnownItemPrice ? MoneyRenderer(orderArticlePrices.itemPrice, 4) : '-'}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: '1px solid #ddd' }}>
                                            <td style={{ textAlign: 'left' , paddingLeft: '0px', borderCollapse: 'collapse'}}>
                                                <td>
                                                    <span
                                                        className="material-symbols-outlined"
                                                        style={{
                                                            color: '#5e5d5d',
                                                            fontSize: "1.2em",
                                                            marginRight: "5px",
                                                            position: "relative",
                                                            top: "4px"
                                                        }}
                                                    >
                                                        <SystemUpdateAltOutlinedIcon/>
                                                    </span>
                                                </td>
                                            </td>
                                            <td style={{ textAlign: 'left', paddingLeft: '10px' }}>Contenido Caja</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontFamily: `'Libre Baskerville', serif`, fontSize: '18px', color: '#c1a17d', fontWeight: '' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>{article.itemsAmount} {feature.itemUnitAbbreviation(article)}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'left' , paddingLeft: '0px', borderCollapse: 'collapse'}}>
                                                <td>
                                                    <span
                                                        className="material-symbols-outlined"
                                                        style={{
                                                            color: '#5e5d5d',
                                                            fontSize: "1.2em",
                                                            marginRight: "5px",
                                                            position: "relative",
                                                            top: "4px"
                                                        }}
                                                    >
                                                        <Inventory2OutlinedIcon/>
                                                    </span>
                                                </td>
                                            </td>
                                            <td style={{ textAlign: 'left', paddingLeft: '10px' }}>Costo Por Caja</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontFamily: `'Libre Baskerville', serif`, fontSize: '18px', color: '#c1a17d', fontWeight: '' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>{MoneyRenderer(orderArticlePrices.price)}</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                    <Box className="modal-footer" sx={{padding: '5px', textAlign: 'center', fontFamily: `'Libre Baskerville', serif`}}>
                        <Typography variant="h4" sx={{ marginBottom: '5px', color: '#ffffff', justifyContent: 'center'}} className="hidden-quantity-boxes-xs">
                            <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold'}}> Cantidad </div>
                        </Typography>
                        <Typography variant="h4" sx={{ marginBottom: '5px', color: '#ffffff', justifyContent: 'center'}} className="visible-quantity-boxes-xs">
                            <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold'}}> Cajas </div>
                        </Typography>
                        <Box
                            className="hidden-quantity-boxes-xs"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginBottom: '20px',
                            }}
                        >
                            {[1, 2, 3, 4, 5].map((value) => (
                                <a
                                    key={value}
                                    onClick={() => handleAddToCart(value)}
                                    className="btn btn-primary btn-add-to-cart"
                                >
                                    {value} Caja{value > 1 ? 's' : ''}
                                </a>
                            ))}
                        </Box>
                        <Box
                            className="visible-quantity-boxes-xs"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginBottom: '20px',
                            }}
                        >

                            {[1, 2, 3, 4, 5].map((value) => (
                                <a
                                    key={value}
                                    onClick={() => handleAddToCart(value)}
                                    className="btn btn-primary btn-add-to-cart"
                                    style={{padding: "0.8em"}}
                                >
                                    {value}
                                </a>
                            ))}
                        </Box>

                        <Box className="modal-footer" sx={{ padding: '5px', textAlign: 'center', fontFamily: `'Libre Baskerville', serif` }}>
                            <Typography
                                variant="h5"
                                sx={{ marginBottom: '5px', fontSize: '18px', color: '#ffffff' }}
                            >
                                <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}> Otra Cantidad </div>
                            </Typography>

                            <TextField
                                type="text"
                                placeholder="Ingresar Cantidad"
                                value={quantity}
                                onChange={(event) => {
                                    let inputValue = event.target.value;
                                    if (!/^\d*$/.test(inputValue)) return;
                                    const value = inputValue === "" ? "" : Math.max(0, parseInt(inputValue, 10));
                                    handleQuantityChange(value);
                                }}
                                sx={{
                                    width: '260px',
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: '5px',
                                        height: '36px',
                                        pr: 0,
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: '8px 10px',
                                        fontSize: '14px',
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ m: 0, p: 0 }}>
                                            <a
                                                variant="contained"
                                                onClick={() => aQuantityWasEntered && handleAddToCart(quantity)}
                                                className="btn btn-primary btn-add-to-cart"
                                                style={{
                                                    padding: '6px 20px',
                                                    height: '34px',
                                                    minWidth: '120px',
                                                    fontSize: '14px',
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                }}
                                            >
                                                Añadir
                                            </a>
                                        </InputAdornment>
                                    ),
                                }}
                            />



                        </Box>

                    </Box>

                </Box>
            </Modal>
        </>
    );
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default observer(CartCheckoutScreen);
